import React from "react";

// Alcuni messaggi (es. "questo PDF è una scansione, non si può mappare")
// arrivano subito dopo un'azione dell'utente ma, mostrati solo come riga di
// testo in fondo alla pagina, rischiano di passare inosservati — l'utente
// resta bloccato senza capire perché. Questo modale li mette in primo
// piano, al centro dello schermo, finché non vengono chiusi esplicitamente.
// Stesso linguaggio visivo di SceltaFoglioModal/SceltaIntestazioneModal, ma
// a tinta d'allarme invece che neutra.
export default function AvvisoModal({ messaggio, onChiudi }) {
  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onChiudi}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "460px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #7f1d1d 0%, #b91c1c 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>⚠️</span>
            <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#fef2f2" }}>
              Attenzione
            </div>
          </div>
          <button className="cf-btn" onClick={onChiudi} style={{ border: "none", background: "rgba(255,255,255,0.12)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#fef2f2", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          <p style={{ margin: 0, color: "var(--cf-text-primary)", lineHeight: 1.5 }}>{messaggio}</p>
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
          <button className="btn-primario" onClick={onChiudi}>Ho capito</button>
        </div>
      </div>
    </div>
  );
}
